<template>
  <div class="align-center mb20" @click="detailsClick">
    <div class="listItem-img">
      <img :src="item.goods_image" alt="">
    </div>
    <div class="cl111 font-bold f15 mt10 mb5">{{ item.goods_name }}</div>
    <div class="cl999  f13 listItem-desc">{{ item.sketch }}</div>
  </div>
</template>
<script>
export default {
  name: "listItem",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    detailsClick() {
      this.$router.push({
        path: "/enterpriseInformation-details?id=" + this.item.goods_id
      })
    }
    /*detailsClick() {
      this.$emit('detailsClick')
    }*/
  }
}
</script>
<style scoped lang="scss">
.listItem {
  &-img {
    width: 100%;
    height: calc(50vw - 15px);
    max-height: 300px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &-desc {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
</style>
